// Step 3
// Enter user Details

import React, { useState, useEffect, useRef } from 'react'
import InputFields from "../../common/input";
import Global from '../../common/global';
import Helper from '../../common/helper';
import ErrorComponent from '../../components/UI/error';

// import InputFields from "../../common/input";
import { 
  CaretUp,
  Promo,
  CheckBoxTick,
  CheckBoxBlank,
  ButtonEdit
} from '../../common/icons'

// static background
import Background from '../../assets/images/business-explorer-review-background.png';
import clsx from 'clsx';

export default function ReviewStep({languages, localStorageDatas, editItemLink, readMeTerms, locationData, handleShowList, 
  inputPromoEl, isRenewalPage, handleCardCheckBox, removeProduct, handleCheckBoxTerms, checkBoxTerms, currentStep, 
  stepNo, editReview, isExpress, memberCreationError, couponObj, isUserLogged, businessCategories}) {

  const [input, setInput] = useState({});
  const [show, setShow] = useState(true)

  if (currentStep !== stepNo) {
    return null
  }

  console.log('localstorageDatas', localStorageDatas)

  var termsAndConditionsLinkURL;
  var pathName = window.location.pathname
  if(isRenewalPage) {
    termsAndConditionsLinkURL = `https://${window.location.host}${pathName.replace("/renewals/", "/")}about/terms-and-conditions`
  } else if(isExpress) {
    termsAndConditionsLinkURL = `https://${window.location.host}${pathName.replace("/express-checkout/", "/")}about/terms-and-conditions`
  } else {
    termsAndConditionsLinkURL = `https://${window.location.host}${pathName.replace("/registration/", "/")}about/terms-and-conditions`
  }
  console.warn('termsandconditionsURL', termsAndConditionsLinkURL)
  const PERSONAL_DETAILS = 'https://secure.accor.com/account/index.en.shtml#/information/personal';
  const SSO_LOGIN = Global.LOGIN_URL;
  var currencyText = "";
  
  if(Object.keys(localStorageDatas.members[0]?.selected_product).length !== 0) {
    if(localStorageDatas && localStorageDatas.members.length > 0 && localStorageDatas.members[0].selected_product && localStorageDatas.members[0].selected_product[0].currency_text) {
      currencyText = localStorageDatas.members[0].selected_product[0].currency_text;
    }
  }

  var totalnum = 0;
  var totalGst = 0;

  if(Object.keys(localStorageDatas.members[0].selected_product).length !== 0) {
    for(var i = 0; i < localStorageDatas.members.length; i++) {
      let price = "";
      let gst = "";
      if(localStorageDatas.members[0].selected_product && localStorageDatas.members[0].selected_product[0].purchase_price) {
        price = parseFloat(localStorageDatas.members[i].selected_product[0].purchase_price)
        gst = parseFloat(localStorageDatas.members[i].selected_product[0].tax_amt)
      }
      totalnum += price;
      totalGst += gst
    }
    var totalAmt = totalnum + totalGst;
  }

  var couponExists = false;
  var totalAmount  = "";

  return(
    <div>
      <div className='flex justify-evenly align-center mt-5'>
        <div className='wrapper-review w-full flex xs:flex-col tablet:px-4'>
          <div className='review-left-pane'>
            {
              localStorageDatas.members.map((item, index) => {
                let selected_item = item.selected_product[0];
                const getCoupon   = Helper.checkCoupon(selected_item, couponObj);
                const PWP         = Helper.newpwpCheck(selected_item, isUserLogged, locationData, businessCategories);
                console.log('localstorageDatas PWP', PWP)

                if(getCoupon.exists == true) {
                  couponExists = true;
                  totalAmount  = getCoupon.total + ' (coupon applied)';
                } else if(item.selected_product && selected_item && selected_item.tax_amt) {
                  totalAmount = parseFloat(selected_item.purchase_price) + parseFloat(selected_item.tax_amt);
                }
                return (
                  <div className='holder-review-details flex flex-col' key={index}>
                    <div className='holder-review-button ml-auto mb-1'>
                      {
                        item.type_of_member === 'primary_owner' ? null : (
                         !isExpress ? (
                            <button
                              type='button'
                              onClick={() => removeProduct(item)}
                            >x {languages.removeText ? languages.removeText : 'Remove'}
                            </button>
                          ) : ''
                        )
                      }
                    </div>
                    {/* <div className='holder-background'>
                      <img className='product-background' src={Background} />
                    </div> */}
                    <div className='holder-title mt-5'>
                      {
                        isRenewalPage || isExpress ? (
                          <>
                            {
                              item.type_of_member === 'supp' && !isExpress ? (
                                <button
                                  className='button-edit'
                                  type='button'
                                  onClick={() => editReview(item)}
                                >
                                  <ButtonEdit />
                                </button>
                              ) : (
                                <a className='button-edit' href={isExpress ? editItemLink() : editItemLink} target="_blank">                                  
                                  <ButtonEdit />
                                </a>
                              )
                            }                          
                          </>
                        ) : (
                          <button
                            className='button-edit'
                            type='button'
                            onClick={() => editReview(item)}
                          >
                            <ButtonEdit />
                          </button>
                        )
                      }
                      
                      {/* <p className='text-xl tracking-tight review-title capitalize text-gray-900 dark:text-white font-montsterrat font-bold'>
                        {item.selected_product[0].item_group_name}
                      </p> */}
                      <p className='text-xl tracking-tight review-title capitalize text-gray-900 dark:text-white font-montsterrat font-bold'>
                        {item.selected_product[0].item_group_description}
                      </p>
                      {PWP.isPWPExclusive ? (
                        <React.Fragment>
                          <div className='py-3'>
                            <span className='font-montsterrat font-medium total-amount'>{PWP.points} </span>
                            <span className='font-montsterrat uppercase'> {languages.reviewPwpText ? languages.reviewPwpText : 'ALL - Accor Live Limitless Reward points'}</span> 
                          </div>                         
                        </React.Fragment>
                      ) : (
                        <div className='py-3'>
                          {PWP.exists && !item.selected_product[0].isQbr && (
                            <React.Fragment>
                              <span className='font-montsterrat font-medium total-amount'>{PWP.points} </span>
                              <span className='font-montsterrat uppercase'> {languages.reviewPwpText ? languages.reviewPwpText : 'ALL - Accor Live Limitless Reward points'}</span>                          
                              <br/>
                              <span className='font-montsterrat font-bold'>{languages.multiProductOr ? languages.multiProductOr : 'OR'}</span>
                              <br/>
                            </React.Fragment>
                          )}
                          {item.selected_product[0].isQbr && (
                            <div className="mb-3">
                              {/* <p className='font-montsterrat'>Earn {item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards*</p> */}
                              {languages.qbrRewardPoints ? (
                                <p className='font-montsterrat'>Earn {item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards and {languages.qbrRewardPoints} ALL reward points</p>
                              ) : (
                                <p className='font-montsterrat'>Earn {item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards*</p>
                              )}
                            </div>
                          )}
                          <span className='font-montsterrat font-medium total-amount'>{totalAmount}</span>
                          <span className='font-montsterrat uppercase'> {item.selected_product[0].currency_text} {languages.reviewPerYear ? languages.reviewPerYear :'Per Year ' }</span>                         
                        </div>
                      )}


                      <div className='pb-3'>
                        <span className='font-montsterrat font-bold'>{languages.reviewQuantity ? languages.reviewQuantity : 'QTY'}: </span>
                        <span>1</span>
                      </div>
                    </div>
                    <div className={clsx('details ', 
                    {
                      'rotated': item.isShown
                    })}>
                      {
                        isExpress && item.type_of_member === "primary_owner"  ? '' : 
                        <button
                          onClick={() => handleShowList(item, index)}
                          className='font-montsterrat font-semibold'>
                          {languages.viewDetails ? languages.viewDetails : 'View details' }
                          <CaretUp className={'icon-caret'}/>
                        </button>
                      }
                      {
                        isExpress && item.type_of_member === "primary_owner" ? (
                          <ul className='details-list'>
                            <li className='list pt-1 font-montsterrat'><strong>{languages.membershipNumber ? languages.membershipNumber : 'Membership number'}</strong> {item.leah_card_number}</li>
                          </ul>
                        ) : isExpress && item.isShown ? (
                          <ul className='details-list'>
                            <li className='list pt-1 font-montsterrat'><strong>{languages.membershipNumber ? languages.membershipNumber : 'Membership number'}</strong> {item.leah_card_number}</li>
                                        
                          </ul>
                        ) : isRenewalPage && item.isShown ? (
                          <ul className='details-list'>
                            <li className='list pt-1 font-montsterrat capitalize'>{item.first_name + ' ' + item.last_name}</li>
                            {/* <li className='list pt-1 font-montsterrat'>{item.phone_number.localNumber === undefined ? item.phone_number : item.phone_number.localNumber}</li> */}
                            <li className='list pt-1 font-montsterrat'>{item.address_line_1} {item.address_line_2}, {item.address_line_3}</li>
                            <li className='list pt-1 font-montsterrat'>{item.city} {item.state}, <span className='uppercase'>{item.postcode}</span></li>
                            <li className='list pt-1 font-montsterrat'> <span>{item.country}</span></li>  
                            <li className='list pt-1 font-montsterrat'>{item.email}</li>  
                          </ul>
                        ) : !isExpress && !isRenewalPage && item.isShown && (
                          <ul className='details-list'> 
                            <li className='list pt-1 font-montsterrat capitalize'>{item.first_name + ' ' + item.last_name}</li>
                            <li className='list pt-1 font-montsterrat'>{item.phone_number.localNumber && item.phone_number.localNumber === undefined ? item.phone_number : item.phone_number.localNumber}</li>
                            <li className='list pt-1 font-montsterrat'>{item.address_line_1} {item.address_line_2}, {item.address_line_3}</li>
                            <li className='list pt-1 font-montsterrat'>{item.city} {item.state}, <span className='uppercase'>{item.postcode}</span></li>
                            <li className='list pt-1 font-montsterrat'> <span>{item.country}</span></li>  
                            <li className='list pt-1 font-montsterrat'>{item.email}</li>  
                          </ul>
                        )
                      }
                    </div>
                      {                      
                        //  localStorageDatas.business_categories[item.selected_product[0].business_category_id].card_delivery_selectable && //dynamic
                        // localStorageDatas.business_categories[item.selected_product[0].business_category_id]?.card_delivery_selectable &&
                        // <div className="flex items-center mt-3">
                        //   <button 
                        //     id={`link-${index}`}
                        //     type="button" 
                        //     checked={item.card}
                        //     onClick={() => handleCardCheckBox(item, index)}
                        //     className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" 
                        //   />
                        //   <label htmlFor={`link-${index}`} className="link-checkbox text-sm font-medium text-gray-900 dark:text-gray-300">
                        //     <span className={`checkbox-icon ${item.card} mr-4`}>{ item.card ? <CheckBoxTick /> : <CheckBoxBlank />}</span>
                        //     {/* <span>Do you want to receive a physical membership card?</span> */}
                        //     {/* <span>Your digital card will be available in the ALL APP. Do you want to receive a physical card as well?</span> */}
                        //     <span>{languages.physicalCardTickbox ? languages.physicalCardTickbox : 'Do you want to receive a physical membership card?'}</span>
                        //   </label>
                        // </div>

                      }                  
                  </div>
                )
              })
            }
          </div>  
          <div className='review-right-pane'>
            {/* <div className='holder-receipt tablet:bordered-gray tablet:bg-white py-10 tablet:px-5'>

                <div className='holder-receipt-content'>
                  {
                    couponExists == false ? (
                      <div>
                        <div className='receipt-list w-full flex flex-row mb-3'>
                          <p className='title text-gray'>{languages.subTotal ? languages.subTotal: 'Sub Total'}</p>
                          <p className='value ml-auto'>{(totalnum).toFixed(2)} <span className='uppercase'>{currencyText}</span></p>
                        </div>
                        <div className='receipt-list w-full flex flex-row'>
                          <p className='title text-gray'>{languages.gst ? languages.gst : 'GST'}</p>
                          <p className='value ml-auto'>{(totalGst).toFixed(2)} <span className='uppercase'>{currencyText}</span></p>
                        </div>
                        <div className='lining'></div>
                      </div>
                    ) : ""
                  }
                  
                  <div className='receipt-list w-full total flex flex-row'>
                    <p className='title text-gray'>{languages.total ? languages.total : 'Total'}</p>
                    <p className='value ml-auto pl-1'>
                      <span className='font-bold'>{(couponExists ? '  ' + totalAmount : parseFloat(totalAmt).toFixed(2))} </span>
                      <span className='uppercase'>{!couponExists ? currencyText : ""}</span>
                    </p>
                  </div>
                </div>
            </div> */}
            <div className="flex items-center mt-5">
              <input 
                id="link-checkbox-terms" 
                type="checkbox" 
                checked={checkBoxTerms}
                onChange={handleCheckBoxTerms}
                className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" 
              />
              <label htmlFor="link-checkbox-terms" className="flex justify-center items-start text-sm font-medium text-gray-900 dark:text-gray-300">
                <span className={`checkbox-icon ${checkBoxTerms} mr-4`}>{ checkBoxTerms ? <CheckBoxTick /> : <CheckBoxBlank />}</span>
                <span ref={readMeTerms} className='text-gray'>
                  {languages.continueToSteps ? languages.continueToSteps : 'CONTINUE TO NEXT STEPS'} <br className=''/>
                  {languages.termsAndConditions ? languages.termsAndConditions : 'I agree and accept the Accor Plus Terms and Conditions and the Accor Plus Data Privacy Charter'} 
                  <a                   
                    className='text-green text-underline'
                    href={termsAndConditionsLinkURL}
                    // href={`https://www.accorplus.com/${locationData.country.toLowerCase()}/about/terms-and-conditions`}
                    target="_blank"
                  >
                    <span> {languages.termsLinkTitle ? languages.termsLinkTitle : 'accessible here'}</span>
                  </a>.
                </span>
              </label>
            </div> 
          </div>
        </div>
      </div>
      {
        (memberCreationError ?
        <div class="mt-5">
          <ErrorComponent errorMessage={memberCreationError}/>
        </div>
        : "")
      }
    </div>
  );
}